import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { ContentManagerCopyMoveModeEnum } from "../../../src/taskpane/components/enums/ContentManagerCopyMoveModeEnum";
import { RootState } from "../../../src/taskpane/components/_v2/redux/storeMain";
import { LanguageContext } from "../../../utilities/LocalizationModule";

export function useMenuItem_SelectedFileCount(selectedItems: any[], waitFor: boolean, setSelectionCleared: (selectionCleared: boolean) => void) {
  const languageStrings = React.useContext(LanguageContext);

  const moveToMode = useSelector((state: RootState) => state.contentManagerDirectory.moveTo.mode);

  const [menuItem_SelectedFileCount, setMenuItem_SelectedFileCount] = React.useState<IContextualMenuItem>();

  React.useEffect(() => {
    if (selectedItems.length > 0 && !waitFor) {
      setMenuItem_SelectedFileCount(
        {
          key: "selectedFileCount",
          text: `${selectedItems.length} ${languageStrings.Selected.toLowerCase()}`,
          disabled: waitFor === true,
          iconProps: { iconName: "Clear" },
          onClick: () => {
            setSelectionCleared(true)
          }
        }
      )
    } 
    // else if (moveToMode === ContentManagerCopyMoveModeEnum.CopyEntireFolderEmails) {
    //   setMenuItem_SelectedFileCount(
    //     {
    //       key: "selectedFileCountEntireFolder",
    //       text: languageStrings.EntireFolderSelected,
    //       disabled: true
    //     }
    //   )
    // } 
    else {
      setMenuItem_SelectedFileCount(null)
    }
  }, [selectedItems, waitFor, moveToMode]);


  return {
    menuItem_SelectedFileCount
  }

}